import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { AppRoleSummary, AppRoleWithPermissions, IAppRoleListOnly } from '~/models/administration/approle';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class AppRolesService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.administration);
  }
  getAppRole(id: number, moduleId?: number) {
    if (moduleId) {
      return this.http.get<AppRoleSummary>(this._url(`/${id}/${moduleId}`));
    }
    else {
      return this.http.get<AppRoleSummary>(this._url(`/${id}/${-1}`));
    }
  }

  getAll(id: number) {
    return this.http.get<AppRoleSummary>(this._url(`/GetAll/${id}`));
  }

  getAppRolePagePermissions(id: number, moduleId: number) {
    return this.http.get<any[]>(this._url(`/${id}/page-permissions/${moduleId}`));
  }

  createAppRole(model: any) {
    return this.client.post<string>(this._url(), model);
  }

  updateAppRole(id: number, model: any) {
    return this.client.put(this._url(`/${id}`), model);
  }

  deleteAppRole(id: number) {
    return this.client.delete(this._url(`/${id}`));
  }

  deactivateAppRole(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }

  reactivateAppRole(obj: any) {
    return this.client.put(this._url(`/reactivate`), obj);
  }

  getAppRoles(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http.post<AppRoleSummary[]>(this._url(`/grid-data`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  getAppRolesForUser(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http.post<AppRoleSummary[]>(this._url(`/grid-data-for-user`), model, { params, observe: 'response' }).pipe(map(augmentPaging));
  }

  getAppRolesListing() {
    return this.http.get<AppRoleWithPermissions[]>(this._url());
  }

  getAppRolesListingOnly() {
    return this.http.get<IAppRoleListOnly[]>(this._url(`/list-only`));
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/approles${v}`);
  }
}
